import React from 'react';
import { FiInbox } from 'react-icons/fi';

function Empty({ objectName = "items", message, action }) {
    return (
        <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
            <div className="w-20 h-20 rounded-full bg-base-200 border border-zinc-200 flex items-center justify-center mb-6">
                <FiInbox className="w-9 h-9 text-zinc-400" />
            </div>

            <h3 className="text-lg font-bold text-base-content mb-2">
                No {objectName} found
            </h3>

            <p className="text-sm text-zinc-500 max-w-sm leading-relaxed">
                {message || `There are currently no ${objectName.toLowerCase()} to display. Check back soon or contact us for more information.`}
            </p>

            {action && (
                <div className="mt-6">
                    {action}
                </div>
            )}
        </div>
    );
}

export default Empty;